(() => {
  const normalize = (value) => (value || '').replaceAll('×', 'x').toLowerCase();
  function selectedVariantId(card) {
    const scope = card.closest('[data-testid="product-information-details"]')?.parentElement || document;
    const input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input?.value || new URL(window.location.href).searchParams.get('variant');
  }
  function syncCard(card) {
    const mapNode = card.querySelector('[data-aw-variant-map]');
    if (!mapNode) return;
    let variants = [];
    try { variants = JSON.parse(mapNode.textContent); } catch (_) { return; }
    const id = selectedVariantId(card);
    const variant = variants.find((item) => item.id.split('/').pop() === String(id).split('/').pop()) || variants[0];
    const title = normalize(variant?.title);
    const heading = card.querySelector('[data-aw-offer-title]');
    const copy = card.querySelector('[data-aw-offer-copy]');
    card.classList.remove('is-unlocked', 'is-gift');
    if (title.includes('canvas / 30x40') || title.includes('30x40 / canvas')) {
      card.classList.add('is-unlocked');
      heading.textContent = 'Your free 11×14 is unlocked.';
      copy.textContent = 'Add this 30×40 canvas, then choose any eligible 11×14 from the weekend collection.';
    } else if (title.includes('canvas / 11x14') || title.includes('11x14 / canvas')) {
      card.classList.add('is-gift');
      heading.textContent = 'This size can be your complimentary canvas.';
      copy.textContent = 'Pair it with an eligible 30×40 canvas and the 11×14 becomes free in your cart.';
    } else {
      heading.textContent = 'Select 30×40 to unlock a free 11×14.';
      copy.textContent = 'Add the statement canvas first. Then choose any eligible 11×14 from the weekend collection.';
    }
  }
  function syncAll() { document.querySelectorAll('[data-aw-product-offer]').forEach(syncCard); }
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('change', () => setTimeout(syncAll, 40));
  document.addEventListener('click', () => setTimeout(syncAll, 120));
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('popstate', syncAll);
})();